/**
 * Shim for React's removed internal "react/lib/ReactTransitionEvents".
 * react-toastr (and other legacy libs) require this for animation end detection.
 * Uses DOM transitionend/animationend instead.
 */
const endEvents = ['transitionend', 'animationend'];

function addEndEventListener(node, listener) {
  if (!node) return;
  const wrapped = (e) => {
    if (e.target === node) listener(e);
  };
  node._reactTransitionEndListeners = node._reactTransitionEndListeners || [];
  node._reactTransitionEndListeners.push({ listener, wrapped });
  endEvents.forEach((evt) => node.addEventListener(evt, wrapped));
}

function removeEndEventListener(node, listener) {
  if (!node || !node._reactTransitionEndListeners) return;
  const entry = node._reactTransitionEndListeners.find((l) => l.listener === listener);
  if (entry) {
    endEvents.forEach((evt) => node.removeEventListener(evt, entry.wrapped));
    node._reactTransitionEndListeners = node._reactTransitionEndListeners.filter((l) => l !== entry);
  }
}

export default { addEndEventListener, removeEndEventListener };
